import { useContext, useEffect, useState } from 'react';
import type { FEATURE_FLAGS } from '../../image/labelling/constants';
import type { FeatureFlagResponseT } from '../providers/feature-flag-provider';
import { FeatureFlagContext } from '../providers/feature-flag-provider';
export type FLAG_VALUES = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
export default function useFeatureFlag<T extends FLAG_VALUES>(featureNames: T | Array<T>): {
  featureFlags: { [featureName in T]: FeatureFlagResponseT } | undefined;
  isLoading: boolean;
} {
  const [featureFlags, setFeatureFlag] = useState<{ [featureName in T]: FeatureFlagResponseT }>();
  const [isLoading, setIsLoading] = useState(false);
  const {
    getFeatureFlag
  } = useContext(FeatureFlagContext);
  useEffect(() => {
    async function fetchFeatureFlags() {
      setIsLoading(true);
      const featureNameList = typeof featureNames === 'string' ? [featureNames] : featureNames;
      const flagResponse = await Promise.allSettled(featureNameList.map(async featureName => await getFeatureFlag(featureName)));
      const calculatedFeatureFlag = flagResponse.reduce<{ [featureName in T]: FeatureFlagResponseT }>((featureFlags, currentResponse, index) => {
        switch (currentResponse.status) {
          case 'fulfilled':
            {
              // @ts-expect-error todo(ts-migration) TS2536 Type 'T | undefined' cannot be used to index type '{ [featureName in T]: FeatureFlagResponseT; }'.
              featureFlags[featureNameList[index]] = currentResponse.value;
              break;
            }
          case 'rejected':
            {
              // @ts-expect-error todo(ts-migration) TS2536 Type 'T | undefined' cannot be used to index type '{ [featureName in T]: FeatureFlagResponseT; }'.
              featureFlags[featureNameList[index]] = {
                error: 'Failed fetching feature'
              };
            }
        }
        return featureFlags;
      }, ({} as { [featureName in T]: FeatureFlagResponseT }));
      setFeatureFlag(calculatedFeatureFlag);
      setIsLoading(false);
    }
    fetchFeatureFlags();
  }, [getFeatureFlag, featureNames]);
  return {
    featureFlags,
    isLoading
  };
}